<template>
  <el-dialog
    :visible="show"
    :show-close="false"
    title="Delete Alert?"
    class="alert-delete-dialog"
  >
    <p>
      <b>{{ (alert.company && alert.company.human_name) || 'All Companies' }}</b>
      has the following active alert.
      Do you want to delete this alert?
    </p>
    <div class="delete-message">
      {{ alert.message }}
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">
        Cancel
      </el-button>
      <el-button
        type="danger"
        @click="$emit('submit')"
      >
        Delete
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'AlertDeleteDialog',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    alert: {
      type: Object,
      default: () => ({
        company: null,
        message: ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-delete-dialog {
  ::v-deep .el-dialog__header {
    padding-bottom: 0;
  }
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
  .delete-message {
    padding: 1em;
    white-space: pre;
    background-color: #f5f7fa; // $--background-color-base
  }
}
</style>
